import {isPlainObject} from 'rlink-type-utils';
/**
 * Returns the entries iterator for the given object.
 *
 * @param  {IterableCollection} obj
 * @return {Iterator}
 */
export default function entries (obj) {
  if (!this.isIterable(obj)) {
    throw new Error(`Cannot iterate non-iterable object: ${obj}`);
  }
  if ( typeof obj.entries === 'function') {
    return obj.entries();
  } else if (isPlainObject(obj)) {
    return Object.entries(obj);
  } else {
    return this.NotApplicable;
  }
}



// WEBPACK FOOTER //
// ./lib/rlink-collections/core/entries.js